import {useMutation} from "@tanstack/react-query";
import axiosClient from "../axiosClient";
import {handleZodError} from "../handleZodError";
import {DEFAULT_EMPLOYEE_REFRESH_TOKEN, EmployeeRefreshTokenResModel, IEmployeeRefreshTokenResModel} from "./dto";

type EmployeeRefreshToken = {
	refreshToken: string;
};

export const fetchEmployeeRefreshToken = async (body: EmployeeRefreshToken) => {
	const {data} = await axiosClient.post<IEmployeeRefreshTokenResModel>("/v1/accounts/employees/refresh-token", body);

	const result = EmployeeRefreshTokenResModel.model.safeParse(data);

	if (result.success) {
		return result.data;
	} else {
		return handleZodError<IEmployeeRefreshTokenResModel>({
			error: result.error,
			defaultData: DEFAULT_EMPLOYEE_REFRESH_TOKEN
		});
	}
};

export const useEmployeeRefreshToken = () => {
	return useMutation({
		mutationFn: fetchEmployeeRefreshToken
	});
};
